import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-teplpset',
  templateUrl: './teplpset.component.html',
  styleUrls: ['./teplpset.component.scss']
})
export class TeplpsetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
